import { NeedleOffIcon } from './NeedleOffIcon';

/**
 * author: Michael Irigoyen
 * id EF95D4D3-9095-412A-A109-BF170FA2A1D9
 * name needle-off
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/needle-off.svg
 * tags
 * - Medical / Hospital 
 */
export const ShotOffIcon = NeedleOffIcon;
export default ShotOffIcon